import type { Patient, Task } from 'fhir/r4';
import moment from 'moment';
import React, { useMemo } from 'react';
import { List } from 'semantic-ui-react';

import SubListItem from './subListItem';

type SubListProps = {
  currentTaskId?: string;
  handleDisableMultiSelect: (isDisabled: boolean) => void;
  handleSelectTask: (taskId: string | undefined) => void;
  handleSelectTasks: (tasks: Task[]) => void;
  selectedTasks: Task[];
  tasks: Task[];
  fhirPatient?: Patient | undefined;
};

const SubList: React.FC<SubListProps> = ({
  currentTaskId,
  handleDisableMultiSelect,
  handleSelectTask,
  handleSelectTasks,
  selectedTasks,
  tasks,
  fhirPatient,
}) => {
  const sortedTasks = useMemo(() => {
    if (!tasks) return [];

    return [...tasks]
      .sort((a, b) => {
        const aDate = moment(a.executionPeriod?.end ?? a.executionPeriod?.start)
          .utc()
          .toDate();
        const bDate = moment(b.executionPeriod?.end ?? b.executionPeriod?.start)
          .utc()
          .toDate();
        return aDate.getTime() - bDate.getTime();
      })
      .sort((a, b) => {
        const priorityMap: Record<string, number> = { routine: 1, urgent: 2, asap: 3, stat: 4 };
        const priorityA = priorityMap[a.priority ?? 'routine'];
        const priorityB = priorityMap[b.priority ?? 'routine'];
        return priorityB! - priorityA!; // Higher priority tasks come first
      });
  }, [tasks]); // Recalculate only when tasksubList changes

  return (
    <List relaxed size="medium">
      {sortedTasks.length > 0 ? (
        sortedTasks.map((task: Task) => (
          <SubListItem
            key={task.id}
            currentTaskId={currentTaskId}
            handleDisableMultiSelect={handleDisableMultiSelect}
            handleSelectTask={handleSelectTask}
            handleSelectTasks={handleSelectTasks}
            selectedTasks={selectedTasks}
            task={task}
            fhirPatient={fhirPatient}
          />
        ))
      ) : (
        <>No Tasks</>
      )}
    </List>
  );
};

export default SubList;
